module.exports = __webpack_public_path__ + "img/2.6729d017.png";